<!-- Bootstrap -->
<!-- <div *ngFor="let s of sizes" class="{{s.css + ' ' + (prefix + s.id) }}">{{s.name}}</div> -->

<!-- Angular flex-layout -->
<div *ngFor="let s of sizes" fxShow.xs="{{s.name == 'xs'}}" fxShow.sm="{{s.name == 'sm'}}"
  fxShow.md="{{s.name == 'md'}}" fxShow.lg="{{s.name == 'lg'}}" fxShow.xl="{{s.name == 'xl'}}"
  class="{{s.css + ' ' + (prefix + s.id) }}">The current screen size is - {{s.name}}
</div>